export default __webpack_public_path__ + "static/media/ic_notes.6da203f1.svg";